// extracted by mini-css-extract-plugin
export default {"container":"category_container__ErBQ0","img":"category_img__V5C0Z"};